<template>
  <div class="ig-employee-list-page">
    <div class="page-container">
      <header class="page-header">
        <div>
          <div class="page-title">
            <span class="title-mark"></span>
            我的入职信息
          </div>
          <p>输入条件筛选后，点击打印登记表</p>
        </div>
        <div class="header-actions">
          <el-button
            type="success"
            icon="el-icon-refresh"
            :loading="loading"
            @click="refreshList"
          >
            刷新
          </el-button>
        </div>
      </header>

      <section class="filter-card">
        <div class="filter-title">
          <i class="el-icon-search"></i>
          查询条件
        </div>
        <el-form
          class="filter-form"
          :model="filterForm"
          label-position="top"
          @submit.native.prevent
        >
          <el-form-item label="姓名">
            <el-input
              v-model.trim="filterForm.Title"
              clearable
              placeholder="请输入姓名"
              @keyup.enter.native="handleSearch"
            />
          </el-form-item>
          <el-form-item label="手机号码">
            <el-input
              v-model.trim="filterForm.MobileNo"
              clearable
              placeholder="请输入手机号码（支持模糊查询）"
              @keyup.enter.native="handleSearch"
            />
          </el-form-item>
          <el-form-item label="派遣公司">
            <el-select
              v-model="filterForm.PqCompany"
              :loading="optionsLoading"
              placeholder="请选择派遣公司"
              clearable
              filterable
            >
              <el-option
                v-for="item in dispatchCompanyOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </el-form-item>
          <el-form-item label="是否派遣工">
            <el-select
              v-model="filterForm.isPq"
              clearable
              placeholder="全部"
            >
              <el-option label="是" value="1" />
              <el-option label="否" value="0" />
            </el-select>
          </el-form-item>
          <el-form-item class="date-range-item" label="填写时间">
            <el-date-picker
              v-model="dateRange"
              type="daterange"
              value-format="yyyy-MM-dd"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
            />
          </el-form-item>
          <div class="filter-actions">
            <el-button
              type="success"
              icon="el-icon-search"
              :loading="loading"
              @click="handleSearch"
            >
              查询
            </el-button>
            <el-button icon="el-icon-refresh-left" @click="resetFilters">
              重置
            </el-button>
          </div>
        </el-form>
      </section>

      <section class="table-card">
        <div class="table-toolbar">
          <div>
            <h2>我的资料列表</h2>
            <p>点击打印按钮可打印登记表</p>
          </div>
          <div class="toolbar-actions">
            <el-button
              type="primary"
              icon="el-icon-printer"
              :disabled="selectedRows.length === 0"
              @click="printSelected"
            >
              打印选中（{{ selectedRows.length }}）
            </el-button>
            <span class="total-tag">共 {{ total }} 条</span>
          </div>
        </div>

        <div class="table-scroll">
          <el-table
            v-loading="loading"
            class="employee-table"
            :data="tableData"
            border
            stripe
            empty-text="未查询到对应的填写记录"
            @selection-change="handleSelectionChange"
          >
            <!-- 支持逐条勾选打印，表头全选已通过样式隐藏（不允许全选打印） -->
            <el-table-column type="selection" width="60" align="center" />
            <el-table-column
              type="index"
              label="序号"
              width="70"
              align="center"
              :index="getRowIndex"
            />
            <el-table-column
              prop="Title"
              label="姓名"
              min-width="110"
              align="center"
              show-overflow-tooltip
            />

            <el-table-column
              prop="ApplyID"
              label="手机号"
              min-width="130"
              align="center"
            />
            <el-table-column
              prop="created"
              label="提交时间"
              min-width="170"
              align="center"
            >
              <template slot-scope="{ row }">
                {{ formatCreated(row.created) }}
              </template>
            </el-table-column>
            <el-table-column
              label="操作"
              width="120"
              align="center"
              fixed="right"
            >
              <template slot-scope="{ row }">
                <el-button
                  type="primary"
                  size="mini"
                  icon="el-icon-printer"
                  @click="printOne(row)"
                >
                  打印
                </el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>

        <div v-if="total > 0" class="pagination-wrapper">
          <el-pagination
            background
            layout="total, sizes, prev, pager, next, jumper"
            :current-page="currentPage"
            :page-size="pageSize"
            :page-sizes="[10, 20, 50, 100]"
            :total="total"
            @size-change="handlePageSizeChange"
            @current-change="handlePageChange"
          />
        </div>
      </section>
    </div>
  </div>
</template>

<script>
import api from "@/apis";

export default {
  name: "EmployeeListMine",
  data() {
    return {
      loading: false,
      optionsLoading: false,
      dispatchCompanyOptions: [],
      tableData: [],
      selectedRows: [],
      currentPage: 1,
      pageSize: 20,
      total: 0,
      dateRange: [],
      filterForm: {
        Title: "",
        MobileNo: "",
        PqCompany: "",
        isPq: "",
      },
      refreshTimer: null,
    };
  },
  created() {
    // 默认填写时间为当天
    const today = new Date();
    const todayStr =
      today.getFullYear() +
      "-" +
      String(today.getMonth() + 1).padStart(2, "0") +
      "-" +
      String(today.getDate()).padStart(2, "0");
    this.dateRange = [todayStr, todayStr];
    this.loadDispatchCompanyOptions();
    this.fetchList();
    // 每隔2分钟自动刷新数据
    this.refreshTimer = setInterval(() => {
      this.fetchList();
    }, 2 * 60 * 1000);
  },
  beforeDestroy() {
    if (this.refreshTimer) {
      clearInterval(this.refreshTimer);
      this.refreshTimer = null;
    }
  },
  methods: {
    // 加载派遣公司下拉选项
    async loadDispatchCompanyOptions() {
      this.optionsLoading = true;
      try {
        const res = await api.getPreEmployeeOptions({ type: "pqcompany" });
        const data = res.data || [];
        // 兼容直接返回字符串数组的情况
        if (Array.isArray(data) && data.every((item) => typeof item === "string")) {
          this.dispatchCompanyOptions = data
            .filter(Boolean)
            .map((item) => ({ value: item, label: item }));
        } else {
          this.dispatchCompanyOptions = Object.values(data)
            .map((item) => {
              const value = item.ID || item.orgid;
              const label = String(item.Title || item.title || "")
                .replace(/\r?\n/g, "")
                .trim();
              return { value: value ? String(value) : "", label };
            })
            .filter((item) => item.value && item.label);
        }
      } catch (error) {
        this.dispatchCompanyOptions = [];
      } finally {
        this.optionsLoading = false;
      }
    },
    displayValue(value) {
      return value === null || value === undefined || value === ""
        ? "-"
        : value;
    },
    formatCreated(value) {
      if (!value || String(value).startsWith("0000-00-00")) return "-";
      return value;
    },
    getRowIndex(index) {
      return (this.currentPage - 1) * this.pageSize + index + 1;
    },
    async fetchList() {
      this.loading = true;
      // 列表刷新后清空勾选，避免打印到已不在当前列表的数据
      this.selectedRows = [];
      try {
        const res = await api.getPreEmployeeList({
          page: this.currentPage,
          pagesize: this.pageSize,
          ...this.getFilterParams(),
        });
        const pageData = res.data || {};
        this.tableData = Array.isArray(pageData.data) ? pageData.data : [];
        this.total = Number(pageData.total) || 0;
        this.pageSize = Number(pageData.per_page) || this.pageSize;
      } catch (error) {
        this.tableData = [];
        this.total = 0;
        this.$message.error("员工信息列表加载失败，请稍后重试");
      } finally {
        this.loading = false;
      }
    },
    refreshList() {
      this.currentPage = 1;
      this.fetchList();
    },
    getFilterParams() {
      const params = Object.keys(this.filterForm).reduce((result, key) => {
        const value = this.filterForm[key];
        if (value !== null && value !== undefined && value !== "") {
          result[key] = typeof value === "string" ? value.trim() : value;
        }
        return result;
      }, {});
      if (this.dateRange && this.dateRange.length === 2) {
        params.startdate = this.dateRange[0];
        params.enddate = this.dateRange[1];
      }
      return params;
    },
    handleSearch() {
      this.currentPage = 1;
      this.fetchList();
    },
    resetFilters() {
      // 重置时填写时间回到当天
      const today = new Date();
      const todayStr =
        today.getFullYear() +
        "-" +
        String(today.getMonth() + 1).padStart(2, "0") +
        "-" +
        String(today.getDate()).padStart(2, "0");
      this.dateRange = [todayStr, todayStr];
      this.filterForm = {
        Title: "",
        MobileNo: "",
        PqCompany: "",
        isPq: "",
      };
      this.currentPage = 1;
      this.fetchList();
    },
    handlePageChange(page) {
      this.currentPage = page;
      this.fetchList();
    },
    handlePageSizeChange(size) {
      this.pageSize = size;
      this.currentPage = 1;
      this.fetchList();
    },
    // 保存当前页勾选的员工，用于批量打印登记表
    handleSelectionChange(rows) {
      this.selectedRows = rows;
    },
    // 打印勾选的员工（不支持全选，只能逐条勾选）
    printSelected() {
      const applyIds = this.selectedRows
        .map((row) => String(row.id || "").trim())
        .filter(Boolean);
      if (!applyIds.length) {
        this.$message.warning("请先勾选需要打印的员工");
        return;
      }
      // 与单条打印保持一致，通过 sessionStorage 传递 ID
      sessionStorage.setItem("printIds", applyIds.join(","));
      const printRoute = this.$router.resolve({
        path: "/employee/print",
      });
      const printWindow = window.open(printRoute.href, "_blank");
      if (!printWindow) {
        this.$message.warning("弹窗被拦截，请允许弹出窗口后重试");
      }
    },
    printOne(row) {
      const applyId = String(row.id || "").trim();
      if (!applyId) {
        this.$message.warning("该员工信息缺少有效ID，无法打印");
        return;
      }
      // 新开打印窗口，通过 sessionStorage 传递 ID，避免 URL 明文暴露
      sessionStorage.setItem("printIds", applyId);
      const printRoute = this.$router.resolve({
        path: "/employee/print",
      });
      const printWindow = window.open(printRoute.href, "_blank");
      if (!printWindow) {
        this.$message.warning("弹窗被拦截，请允许弹出窗口后重试");
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.ig-employee-list-page {
  width: 100%;
  min-height: 100vh;
  padding: 28px;
  font-size: 22px;
  color: #303133;
  background: #f3f6f5;
  box-sizing: border-box;
}

.page-container {
  width: 100%;
  margin: 0;
}

.page-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  min-height: 104px;
  padding: 22px 30px;
  color: #fff;
  background: linear-gradient(135deg, #178a50, #20aa68);
  border-radius: 14px;
  box-shadow: 0 8px 24px rgba(20, 126, 74, 0.18);
  box-sizing: border-box;

  p {
    margin: 8px 0 0 18px;
    font-size: 22px;
    color: rgba(255, 255, 255, 0.82);
  }

  .warning-tip {
    margin-top: 4px;
    font-size: 22px;
    color: #ffd966;
  }
}

.page-title {
  display: flex;
  align-items: center;
  font-size: 30px;
  font-weight: 600;
}

.title-mark {
  width: 5px;
  height: 27px;
  margin-right: 13px;
  background: #fff;
  border-radius: 3px;
}

.header-actions {
  display: flex;
  gap: 10px;
}

.filter-card {
  margin-top: 20px;
  padding: 24px;
  background: #fff;
  border: 1px solid #e5ece8;
  border-radius: 12px;
  box-shadow: 0 5px 18px rgba(31, 67, 49, 0.06);
}

.filter-title {
  display: flex;
  align-items: center;
  margin-bottom: 20px;
  font-size: 26px;
  font-weight: 600;
  color: #25352d;

  i {
    margin-right: 10px;
    color: #1fa463;
  }
}

.filter-form {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));
  align-items: end;
  gap: 18px 20px;
}

.date-range-item {
  grid-column: span 2;
}

.filter-actions {
  display: flex;
  align-items: center;
  min-height: 52px;
  gap: 12px;

  .el-button {
    flex: 1;
    min-width: 100px;
    margin: 0;
  }
}

::v-deep .filter-form .el-form-item {
  margin: 0;
}

::v-deep .filter-form .el-form-item__label {
  padding-bottom: 8px;
  font-size: 22px;
  line-height: 30px;
  color: #45534c;
}

::v-deep .filter-form .el-input,
::v-deep .filter-form .el-select,
::v-deep .filter-form .el-date-editor {
  width: 100%;
}

::v-deep .filter-form .el-input__inner {
  height: 52px;
  font-size: 22px;
  line-height: 52px;
}

::v-deep .filter-form .el-input__icon {
  font-size: 22px;
  line-height: 52px;
}

::v-deep .filter-form .el-date-editor--daterange {
  height: 52px;
  padding: 3px 14px;
}

::v-deep .filter-form .el-range-input,
::v-deep .filter-form .el-range-separator {
  font-size: 22px;
}

::v-deep .filter-form .el-range-separator {
  width: 44px;
  line-height: 44px;
}

::v-deep .filter-form .el-button {
  height: 52px;
  padding: 0 20px;
  font-size: 22px;
}

.table-card {
  margin-top: 20px;
  padding: 24px;
  background: #fff;
  border: 1px solid #e5ece8;
  border-radius: 12px;
  box-shadow: 0 5px 18px rgba(31, 67, 49, 0.06);
}

.table-toolbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 20px;

  h2 {
    margin: 0;
    font-size: 24px;
    font-weight: 600;
    color: #25352d;
  }

  p {
    margin: 7px 0 0;
    font-size: 20px;
    color: #909a94;
  }
}

.toolbar-actions {
  display: flex;
  align-items: center;
  gap: 14px;
}

.total-tag {
  padding: 6px 13px;
  font-size: 20px;
  color: #1b9258;
  background: #eaf7f0;
  border-radius: 16px;
}

.table-scroll {
  width: 100%;
  overflow-x: auto;
}

.employee-table {
  width: 100%;
  min-width: 720px;
}

.pagination-wrapper {
  display: flex;
  justify-content: flex-end;
  margin-top: 22px;
}

::v-deep .employee-table th {
  color: #45534c;
  background: #f5f8f6;
}

::v-deep .employee-table .cell {
  font-size: 20px;
  line-height: 30px;
}

::v-deep .employee-table .el-table__body .cell {
  font-size: 24px !important;
  line-height: 34px;
}

::v-deep .employee-table .el-table__body td {
  padding: 14px 0;
}

::v-deep .page-header .el-button,
::v-deep .toolbar-actions .el-button,
::v-deep .employee-table .el-button {
  font-size: 20px;
}

::v-deep .employee-table .el-button {
  padding: 8px 12px;
}

/* 不允许全选打印：隐藏表头的全选勾选框，只能逐条勾选 */
::v-deep .employee-table .el-table__header-wrapper .el-checkbox {
  display: none;
}

::v-deep .employee-table .el-checkbox__inner {
  width: 22px;
  height: 22px;
}

::v-deep .employee-table .el-checkbox__inner::after {
  top: 3px;
  left: 7px;
  width: 5px;
  height: 11px;
}

::v-deep .el-pagination,
::v-deep .el-pagination button,
::v-deep .el-pagination span:not([class*="suffix"]),
::v-deep .el-pager li {
  font-size: 20px;
}

::v-deep .el-pagination button,
::v-deep .el-pager li {
  min-width: 36px;
  height: 36px;
  line-height: 36px;
}

::v-deep .el-pagination .el-input__inner {
  height: 36px;
  font-size: 20px;
  line-height: 36px;
}

::v-deep .el-pagination .el-select .el-input {
  width: 130px;
}

::v-deep .el-pagination__jump {
  height: 36px;
  font-size: 20px;
  line-height: 36px;
}

::v-deep .el-loading-mask.el-loading-fade-leave-active {
  pointer-events: none;
}

@media (max-width: 768px) {
  .ig-employee-list-page {
    padding: 14px;
  }

  .page-header {
    align-items: flex-start;
    flex-direction: column;
    padding: 20px;
  }

  .page-title {
    font-size: 22px;
  }

  .header-actions {
    width: 100%;
    margin-top: 18px;

    .el-button {
      flex: 1;
      margin: 0;
    }
  }

  .filter-card {
    padding: 18px 14px;
  }

  .filter-form {
    grid-template-columns: 1fr;
  }

  .date-range-item {
    grid-column: span 1;
  }

  .table-card {
    padding: 18px 14px;
  }

  .table-toolbar {
    align-items: flex-start;
    flex-direction: column;
  }

  .pagination-wrapper {
    justify-content: center;
    overflow-x: auto;
  }
}
</style>
